import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from '../../api/ApiService';
import LocalDataService from '../../api/LocalDataService';

function TokenLogin() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      const token = new URLSearchParams(location.search).get('token');
      if (!token) {
        toast.error('缺少登录令牌');
        history.replace('/login');
        return;
      }

      try {
        const userInfo = await new ApiService().get_user_info(token);
        LocalDataService.set_user_data({ ...userInfo, token: userInfo?.token || token });
        history.replace('/');
      } catch (error) {
        toast.error('令牌登录失败');
        history.replace('/login');
      }
    };

    run();
  }, [history, location.search]);

  return <main className="canvas-auth-callback"><div className="canvas-auth-callback-mark">剧</div><h1>正在登录…</h1></main>;
}

export default TokenLogin;
